<template>
	<div class="search-wrap">
		<transition name="fade" mode="out-in">
			<form class="search-form" action="/search" method="get" @submit.prevent="goToSearch" v-if="open || $store.state.screenWidth < 980">
				<input-text v-model="search" label="Search" :errors="errors.search"></input-text>
				<button type="submit" class="mobile-toggle"><icon icon="essentials/search/find-circle"></icon></button>
			</form>
		</transition>
		<button @click.prevent="open = !open" class="mobile-toggle" v-if="$store.state.screenWidth >= 980">
			<transition name="fade" mode="out-in">
				<icon icon="essentials/search/find-circle" v-if="!open"></icon>
				<icon icon="essentials/basics/close-circle" v-else="open"></icon>
			</transition>
		</button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				search: (this.$route.query.q || ''),
				open: (this.$route.query.q) ? true : false,
				errors: {}
			};
		},
		watch: {
			'$route.query.q': function() {
				this.search = this.$route.query.q || '';
			}
		},
		methods: {
			async goToSearch() {
				this.errors = {};
				if(!this.search) {
					this.errors.search = ['Search term is required'];
					return;
				}
				this.$emit('open');
				await this.$navigate('/search?q=' + this.search);
			}
		}
	}
</script>